const sliderTraguardi = () => {
    const sections = document.querySelectorAll('.slider-traguardi');
    if (!sections.length) return;

    sections.forEach(section => {
        const slider = section.querySelector('.slider-traguardi__swiper');
        if (!slider) return;

        const textItems = section.querySelectorAll('.slider-traguardi__text-item');

        new Swiper(slider, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: true,
            centeredSlides: true,
            allowTouchMove: false,
            navigation: {
                prevEl: section.querySelector('.slider-traguardi__btn-prev'),
                nextEl: section.querySelector('.slider-traguardi__btn-next'),
            },
            on: {
                slideChange() {
                    const idx = this.realIndex;
                    textItems.forEach((item, i) => {
                        item.classList.toggle('is-active', i === idx);
                    });
                },
                click(swiper) {
                    const slide = swiper.clickedSlide;
                    if (!slide) return;
                    const realIdx = parseInt(slide.dataset.swiperSlideIndex ?? swiper.clickedIndex);
                    swiper.slideToLoop(realIdx);
                },
            },
        });
    });
};

export default sliderTraguardi;
